import Icon from "./icon.vue";
export default {
  name: "Window",

  data() {
    return {
      windowHidden: !!this.hidden
    };
  },

  components: {
    Icon
  },
  props: {
    hidden: Boolean,
    onShow: Function,
    onClose: Function
  },
  methods: {
    show() {
      this.windowHidden = false;
    },

    close() {
      this.windowHidden = true;
      this.onClose && this.onClose();
    }

  }
};